export function normalizeRut(value = '') {
  const clean = value.toString().replace(/[^0-9kK]/g, '').toUpperCase()
  if (clean.length < 2) return clean
  return `${clean.slice(0, -1)}-${clean.slice(-1)}`
}

export function formatRut(value = '') {
  const normalized = normalizeRut(value)
  if (!normalized.includes('-')) return normalized
  const [body, verifier] = normalized.split('-')
  return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${verifier}`
}

export function isValidRut(value) {
  const normalized = normalizeRut(value)
  const [body, verifier] = normalized.split('-')
  if (!/^\d{7,8}$/.test(body) || !/^[0-9K]$/.test(verifier)) return false

  let sum = 0
  let multiplier = 2
  for (let index = body.length - 1; index >= 0; index -= 1) {
    sum += Number(body[index]) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }

  const result = 11 - (sum % 11)
  const expected = result === 11 ? '0' : result === 10 ? 'K' : String(result)
  return verifier === expected
}

// El PIN del portal del socio son los primeros 4 dígitos del cuerpo del RUT.
export const PORTAL_PIN_LENGTH = 4
